export default "__VITE_ASSET__BFZ5TwjG__"